if ($('.see-password').length) {
  $('.fa-eye').on('click', function(event) {
    let openEye = event.currentTarget
    let parentDiv = openEye.closest('.see-password')
    let closedEye = parentDiv.querySelector('.fa-eye-slash')
    let input = parentDiv.querySelector('.see-password-input')

    openEye.classList.add('d-none')
    closedEye.classList.remove('d-none')
    input.setAttribute('type', 'text')
  })

  $('.fa-eye-slash').on('click', function(event) {
    let closedEye = event.currentTarget
    let parentDiv = closedEye.closest('.see-password')
    let openEye = parentDiv.querySelector('.fa-eye')
    let input = parentDiv.querySelector('.see-password-input')

    openEye.classList.remove('d-none')
    closedEye.classList.add('d-none')
    input.setAttribute('type', 'password')
  })
}
